import { render, staticRenderFns } from "./killswitch.vue?vue&type=template&id=25a2ed62&scoped=true&"
import script from "./killswitch.vue?vue&type=script&lang=js&"
export * from "./killswitch.vue?vue&type=script&lang=js&"
import style0 from "./killswitch.vue?vue&type=style&index=0&id=25a2ed62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a2ed62",
  null
  
)

export default component.exports